import React from 'react';
import './index.scss';

export default function TitleTab({ title, className = "" }) {
  return (
    <div className={`title-tab ${className}`}>
      <h1>{title}</h1>
    </div>
  );
}
